import { reportEvent } from '../../../services/analyticsService';
import { getRequest, postRequest } from '../../../services/requestService';
import * as types from './types';
import { push } from 'connected-react-router';

export const setModalState = (key, val, modalParams = {}) => async dispatch => {
  const updatedPayload = {
    [key]: val,
  }
  if (Object.values(modalParams).length > 0) {
    updatedPayload.modalParams = modalParams
  }
  if (modalParams.savedJob) {
    updatedPayload.savedJob = modalParams.savedJob
  }
  dispatch({
    type: types.SET_MODAL_STATE,
    payload: updatedPayload
  })
}

export function updateModalParams(modalParams) {
  return {
    type: types.SET_MODAL_STATE,
    payload: { modalParams }
  }
}

export const triggerResumeEditor = ({ resume, savedJob }) => async dispatch => {
  const resumeData = await getRequest(`resume/${resume._id}`)
  dispatch({
    type: types.SET_MODAL_STATE,
    payload: { resume: resumeData.resume, savedJob: savedJob ? { ...savedJob } : undefined }
  })
  dispatch(push(`/resume-builder/${resume._id}/design`))
}

export function updateSavedJob(savedJob) {
  return {
    type: types.SET_MODAL_STATE,
    payload: {savedJob}
  }
}

export function triggerCoverLetterModal({ savedJob }) {
  return {
    type: types.SET_MODAL_STATE,
    payload: {  savedJob: savedJob ? { ...savedJob } : undefined, isCoverLetterModalOpen: true }
  }
}

export function triggerApplicationModal({ savedJob }) {
  reportEvent('application_modal', 'open', {savedJobId: savedJob._id})
  return {
    type: types.SET_MODAL_STATE,
    payload: {  savedJob: savedJob ? { ...savedJob } : undefined, isApplicationModalOpen: true }
  }
}

export const updateTask = (savedJob, key, value) => async dispatch => {
  const updatedTasks = { ...savedJob.tasks || {}, [key]: value }
        await postRequest('saved-job/update', { savedJobId: savedJob._id, tasks: updatedTasks })
        const updatedSavedJob = {
            ...savedJob,
            tasks: updatedTasks
        }
        dispatch(updateSavedJob(updatedSavedJob))
}